import phone from "phone"

const lessThanString = (length: number) => ({ message: `Must be ${length} characters or longer` })
const moreThanString = (length: number) => ({ message: `Must be ${length} characters or less` })

// RFC 5321 maximum email address length
const MAX_EMAIL_LENGTH = 320

/**
 * Validates if a phone number is a valid Singapore mobile number
 * @param phoneNumber - The phone number to validate
 * @returns true if valid Singapore number, false otherwise
 */
const isValidSingaporePhoneNumber = (phoneNumber: string): boolean => {
    if (!phoneNumber || phoneNumber.trim().length === 0) {
        return false
    }
    const phoneNumberValidation = phone(phoneNumber, { country: `SG` })
    return phoneNumberValidation.isValid
}

/**
 * Validates if an email address is in valid format
 * Uses a standard email regex pattern that is resistant to ReDoS attacks
 * @param email - The email address to validate
 * @returns true if valid email format, false otherwise
 */
const isValidEmail = (email: string): boolean => {
    if (!email || email.trim().length === 0) {
        return false
    }
    // Email regex pattern with atomic groups to prevent catastrophic backtracking
    // Pattern: one or more non-whitespace/@ chars, @, one or more non-whitespace/@ chars, ., one or more non-whitespace/@ chars
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const trimmedEmail = email.trim()

    // Additional length check to prevent potential ReDoS with extremely long strings
    if (trimmedEmail.length > MAX_EMAIL_LENGTH) { // RFC 5321 email length limit
        return false
    }

    return emailRegex.test(trimmedEmail)
}

export {
    lessThanString,
    moreThanString,
    isValidSingaporePhoneNumber,
    isValidEmail,
}